export default __webpack_public_path__ + "static/june24laeye-9bc6c8ec63b83713ea007e587c23c3b9.png";